// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../config/screen';

export const Element = styled.div`
  /* *************** BACKGROUND COLOR *************** */
  background-color: ${({ theme }) => theme.color.moduleHeader.backgroundColor};
  padding: 0.75rem 1rem;
  border-radius: 4px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  max-width: 100%;
  border-radius: 4px;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 1rem 1.5rem;
  };

  /* *************** FOCUS *************** */
  :focus {
    outline: none;
  };
`;

export const IconContainer = styled.div`
  /* *************** BACKGROUND COLOR *************** */
  background-color: ${({ theme }) => theme.color.moduleHeader.buttonBackgroundColor};
  padding: 2px 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: none;
  height: 20px;
  width: 22px;

  > svg {
    width: 16px;
    height: 16px;
    /* *************** ICON COLOR *************** */
    color: ${({ theme }) => theme.color.moduleHeader.iconColor};
    fill: ${({ theme }) => theme.color.moduleHeader.iconColor};
  };
`;

export const Container = styled.div`
  display: flex;
  height: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const TitleContainer = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
`;

export const ContentContainer = styled.div`
  max-width: 100%;
  overflow: hidden;
`;
